import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

const useListProjectPlansAllowed = () => useFeatureAvailable(Feature.PROJECT_PLAN);

export default useListProjectPlansAllowed;
